var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ul', {
    staticClass: "actions-container"
  }, [_c('li', [_c('button', {
    staticClass: "text-format-button pure-button",
    class: _vm.options.isBoldDisabled ? 'disabled' : '',
    attrs: {
      "aria-label": "Bold",
      "tabindex": "0"
    },
    on: {
      "click": function (e) {
        return _vm.handleAction(e, 'bold');
      }
    }
  }, [_c('svg', {
    attrs: {
      "aria-label": "Bold",
      "height": "50",
      "role": "img",
      "width": "50"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.svg.boldSvg)
    }
  })])]), _c('li', [_c('button', {
    staticClass: "text-format-button pure-button",
    class: _vm.options.isItalicDisabled ? 'disabled' : '',
    attrs: {
      "aria-label": "Italic",
      "tabindex": "0"
    },
    on: {
      "click": function (e) {
        return _vm.handleAction(e, 'italic');
      }
    }
  }, [_c('svg', {
    attrs: {
      "aria-label": "Italic",
      "height": "50",
      "role": "img",
      "width": "50"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.svg.italicSvg)
    }
  })])]), _c('li', [_c('button', {
    staticClass: "text-format-button pure-button",
    class: _vm.options.isUnderlineDisabled ? 'disabled' : '',
    attrs: {
      "aria-label": "Underline",
      "tabindex": "0"
    },
    on: {
      "click": function (e) {
        return _vm.handleAction(e, 'underline');
      }
    }
  }, [_c('svg', {
    attrs: {
      "aria-label": "Underline",
      "height": "50",
      "role": "img",
      "width": "50"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.svg.underlineSvg)
    }
  })])]), _vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }